/* ------------------------------------------------------------------------------
@name: Footer
@description: Footer
--------------------------------------------------------------------------------- */

import WindowResize from '@utilities/WindowResize';

const Footer = (() => {
  // - handleSet
  const handleSet = () => {
    if ($(window).width() >= 992) {
      const $footerHeight = $('.footer').outerHeight();
      $('.js-main-site').css('padding-bottom', $footerHeight);
    } else {
      $('.js-main-site').removeAttr('style');
    }
  };

  // - init
  const init = () => {
    handleSet();
    WindowResize.resize(handleSet);
  };

  return {
    init
  };
})();

export default Footer;
